<div class="row mb-2"></div>

<div class="main-card mb-3 card">
  <div
    class="card-header d-flex justify-content-between align-items-center font-weight-bold fs-1r"
  >
    Driver Load Alerts
  </div>

  <div class="table-responsive">
    <table
      class="align-middle mb-0 table table-borderless table-striped table-hover"
      id="excel-table"
    >
      <thead>
        <tr class="align-middle">
          <th>Driver Name</th>
          <th>Phone No</th>
          <th>From</th>
          <th>To</th>
          <th>Status</th>
          <th>Expire On</th>
          <th class="text-end">Created On</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let data of allPosts
              | paginate
                : {
                    itemsPerPage: itemsPerPage,
                    currentPage: page,
                    totalItems: totalItems
                  }
          "
        >
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    {{ data.driverName }}
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    {{ data.phoneNumber }}
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    {{ data.pickupLocationCity }},
                    {{ data.pickupLocationState }}
                  </div>
                </div>
              </div>
            </div>
          </td>

          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    {{ data.dropLocationCity }}, {{ data.dropLocationState }}
                  </div>
                </div>
              </div>
            </div>
          </td>

          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    {{ data.isActive ? "Active" : "Inactive" }}
                  </div>
                </div>
              </div>
            </div>
          </td>

          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    {{ data.expiryDate | date : "dd MMM yyyy" : "en-IN" }}
                  </div>
                </div>
              </div>
            </div>
          </td>

          <td  class="text-end">
            <div class="widget-content p-0 ">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    {{
                      data.createdAt | date : "dd MMM yyyy " : "en-IN"
                    }}
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <div *ngIf="allPosts?.length == 0" class="text-center mt-5 mb-5">
        <span class="text-danger">Data Not found</span>
      </div>
    </table>
    <!-- <pagination-controls class="my-pagination" (pageChange)="gty((page = $event))"></pagination-controls> -->

    <ngb-pagination
      (pageChange)="getAllDriverAlerts((page = $event))"
      [collectionSize]="totalItems"
      [(page)]="page"
      [pageSize]="itemsPerPage"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="false"
    >
    </ngb-pagination>
  </div>
</div>
